import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Timer } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1542838132-92c53300491e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxmcmVzaCUyMGdyb2NlcmllcyUyMHByb2R1Y2UlMjBtYXJrZXR8ZW58MHx8fHwxNzg2ODMwNTM2fDA&ixlib=rb-4.1.0&q=85";

export const HeroVisual = () => {
  const imgRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: imgRef,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const rotate = useTransform(scrollYProgress, [0, 1], [-2, 2]);

  return (
    <div className="relative lg:col-span-5" ref={imgRef}>
      <motion.div
        initial={{ opacity: 0, scale: 0.94 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.1, delay: 0.5, ease: [0.16, 1, 0.3, 1] }}
        className="relative"
      >
        <motion.div
          style={{ rotate }}
          className="overflow-hidden rounded-t-[12rem] rounded-b-3xl shadow-[0_40px_80px_-30px_rgba(4,47,30,0.35)]"
        >
          <motion.img
            src={HERO_IMG}
            alt="Fresh produce picked for delivery"
            data-testid="hero-image"
            style={{ y }}
            className="h-[480px] w-full scale-110 object-cover lg:h-[620px]"
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.2 }}
          className="absolute -left-6 bottom-10 flex items-center gap-3 rounded-2xl border border-white/40 bg-white/70 px-5 py-4 shadow-xl backdrop-blur-xl"
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-fresh/15">
            <Timer className="h-5 w-5 text-fresh" />
          </span>
          <span>
            <span className="block font-syne text-xl font-bold text-forest">20 min</span>
            <span className="block text-xs font-semibold uppercase tracking-wider text-forest/60">
              average delivery
            </span>
          </span>
        </motion.div>
      </motion.div>
    </div>
  );
};
